export default __webpack_public_path__ + "static/media/red-download-arrow.c790d681.svg";